<div class="container-fluid">
  <div class="row">
    <div class="col-12 align-self-center">
      <div class="welcom-rt text-center">
        <h1>WELCOME TO <br> <span>BHAKTS</span></h1>
      </div>
    </div>
  </div>
</div>
